import { render, staticRenderFns } from "./AppDrag.vue?vue&type=template&id=7f7b3f6e&scoped=true&"
import script from "./AppDrag.vue?vue&type=script&lang=js&"
export * from "./AppDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7b3f6e",
  null
  
)

export default component.exports